import { all, fork } from "redux-saga/effects";
import remittanceSaga from "../pages/remittance-beta/state/remittanceSaga";

export default function* rootSaga() {
  yield all([
    fork(remittanceSaga),
  ])
}